module.exports = __webpack_public_path__ + "img/attack_watertornado.c86d8037.png";